import React from 'react'
import DevTools from '../../dev-tools/DevTools'
import V3DataRouteShell from '../data/V3DataRouteShell'

export default function V3DevToolsPage() {
  return (
    <V3DataRouteShell>
      <DevTools />
    </V3DataRouteShell>
  )
}

